import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Cookie } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { useLanguage } from "../i18n";

const KEY = "ogstay-cookie-consent";

const COPY = {
  it: {
    title: "Cookie? Solo quelli tecnici.",
    text: "Usiamo solo cookie tecnici per far funzionare il sito. Il portale di prenotazione e la mappa sono servizi esterni con proprie policy.",
    accept: "OK, ho capito",
    link: "Leggi la policy",
  },
  en: {
    title: "Cookies? Only technical ones.",
    text: "We only use technical cookies to make the site work. The booking portal and the map are external services with their own policies.",
    accept: "Got it",
    link: "Read the policy",
  },
};

export default function CookieBanner() {
  const { lang } = useLanguage();
  const navigate = useNavigate();
  const c = COPY[lang];
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!localStorage.getItem(KEY)) {
      const t = setTimeout(() => setVisible(true), 1500);
      return () => clearTimeout(t);
    }
  }, []);

  const accept = () => {
    localStorage.setItem(KEY, new Date().toISOString());
    setVisible(false);
  };

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          data-testid="cookie-banner"
          initial={{ opacity: 0, y: 40 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: 40 }}
          transition={{ duration: 0.5, ease: [0.22, 1, 0.36, 1] }}
          className="fixed bottom-3 left-3 right-3 z-[65] sm:bottom-6 sm:left-6 sm:right-auto sm:max-w-md"
          role="dialog"
          aria-label={c.title}
        >
          <div className="rounded-[1.5rem] bg-navy p-6 text-white shadow-[0_30px_70px_-20px_rgba(15,43,58,0.6)] ring-1 ring-white/10">
            <p className="flex items-center gap-2.5 font-display text-lg font-semibold">
              <Cookie className="h-5 w-5 text-sky" />
              {c.title}
            </p>
            <p className="mt-2.5 text-sm leading-relaxed text-white/70">{c.text}</p>
            <div className="mt-5 flex flex-wrap items-center gap-3">
              <button data-testid="cookie-accept-button" onClick={accept} className="btn-primary !px-6 !py-2.5 text-[13px]">
                {c.accept}
              </button>
              <button
                data-testid="cookie-policy-link"
                onClick={() => {
                  accept();
                  navigate("/cookie-policy");
                }}
                className="text-xs font-bold uppercase tracking-[0.15em] text-white/70 underline-offset-4 transition-colors hover:text-sky hover:underline"
              >
                {c.link}
              </button>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
